export const isTypeOf = (config, type) => (config?.type ?? config) === type;
